module.exports = __webpack_public_path__ + "img/venues-djs-grey.fe2cf847.svg";